module.exports = __webpack_public_path__ + "img/vertical_7_5_6005.1bd47154.png";